import styled from 'styled-components';
import { Wrapper as Button } from '@spa/shared/components/Unisystem/Button/styles';
import { Wrapper as StatusBanner } from '@spa/shared/components/Unisystem/StatusBanner/styles';
export var MainWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1jq8m7l-0"
})(["position:fixed;z-index:1;width:100%;bottom:0;border-radius:20px;margin-bottom:0;> ", "{margin:", ";box-shadow:", ";}"], StatusBanner, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.pricingBox.notification.boxShadow;
});
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1jq8m7l-1"
})(["display:flex;flex-direction:column;", " background:", ";border-radius:20px 20px 0 0;height:fit-content;border-top:1px solid ", ";padding:", ";color:", ";> ", "{width:100%;}& > p{font-size:", ";color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2, 'column');
}, function (props) {
  return props.theme.pricingBox.background;
}, function (props) {
  return props.theme.pricingBox.border;
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.pricingBox.price.mainColor;
}, Button, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.pricingBox.dates.label;
});
export var Content = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1jq8m7l-2"
})(["width:100%;display:flex;justify-content:space-between;align-items:center;", "{min-width:160px;width:fit-content;}"], Button);
export var LeftSection = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1jq8m7l-3"
})(["display:flex;flex-direction:column;justify-content:space-between;gap:", ";"], function (props) {
  return props.theme.space(1);
});
export var Price = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1jq8m7l-4"
})(["font-size:", ";line-height:", ";color:", ";font-weight:600;", " span{color:", ";font-weight:500;font-size:", ";}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.pricingBox.price.mainColor;
}, function (_ref2) {
  var isClickable = _ref2.isClickable;
  return isClickable && "\n      text-underline-offset: 2px;\n      text-decoration-line: underline;\n      text-decoration-thickness: from-font;\n  ";
}, function (props) {
  return props.theme.pricingBox.price.secondaryColor;
}, function (props) {
  return props.theme.rem(16);
});
export var Dates = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1jq8m7l-5"
})(["display:flex;align-items:center;font-size:", ";line-height:", ";gap:", ";color:", ";", ""], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.pricingBox.dates.label;
}, function (_ref3) {
  var hasDates = _ref3.hasDates;
  return hasDates && "\n      color: ".concat(function (props) {
    return props.theme.pricingBox.dates.date;
  }, ";\n      border-bottom: 1px solid ").concat(function (props) {
    return props.theme.pricingBox.dates.border;
  }, ";\n  ");
});